<template>
  <Layout>
    <!-- Start Service Area -->
    <section class="rn-service-area rn-section-gap">
      <div class="container">
        <div class="row row--30">
          <div class="col-lg-12">
            <SectionTitle
              class="mb--50"
              text-align="center"
              subtitle="Where People and Technology Intersect"
              title="Serving the Needs of Our Clients"
              data-aos="fade-up"
              data-aos-delay="60"
            />
          </div>
        </div>
        <div class="row row--15 service-wrapper">
          <div class="col-12">
            <ServiceCard
              :service="{
                  icon: 'user-plus',
                  id: 'growth-leadership',
                  title: 'Growth Leadership',
                  description: '<p>We offer ongoing advisory sessions, leadership coaching, and fractional engineering leadership to help your teams stay aligned, make strong decisions, and navigate future growth confidently.</p><h2>What\'s Included</h2><ul><li>Monthly or quarterly advisory sessions</li><li>Executive-level guidance on strategy, planning, and org design</li><li>Fractional engineering leadership support</li><li>Coaching for managers, directors, and senior engineers</li><li>Thought partnership for high-stakes decisions</li><li>Periodic reviews of delivery, structure, and culture</li></ul><h2>The Outcome</h2><p>A sustainable, long-term partnership that helps your organization continue to grow with clarity, avoid regression, and operate with strong, confident leadership—without requiring a full-time engineering executive.</p>'
                  }"
              :service-style="`service__style--1 bg-color-blackest radius mt--25`"
              :icon-size="62"
              text-align="left"
            />
          </div>
        </div>
      </div>
    </section>
    <!-- End Service Area -->

  </Layout>
</template>

<script>
    import Layout from '../../components/common/Layout'
    import SectionTitle from '../../components/elements/sectionTitle/SectionTitle'
    import ServiceCard from '../../components/elements/service/ServiceCard'

    export default {
        name: 'GrowthLeadership',
        components: {Layout, SectionTitle, ServiceCard},
    }
</script>
